import get from "lodash/get";
import set from "lodash/set";
import {
  FiltersV2StoreSetter,
  FiltersV2StoreType
} from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";
import { ConditionalPick } from "type-fest";

type ToggleableFiltersV2StoreFields = string &
  (
    | keyof ConditionalPick<FiltersV2StoreType, boolean>
    | `buffer.${keyof ConditionalPick<FiltersV2StoreType["buffer"], boolean>}`
  );

export const getTogglePropertyAction =
  (updateStore: FiltersV2StoreSetter, propertyPath: ToggleableFiltersV2StoreFields) => (toggle?: boolean) => {
    updateStore((draftState) => {
      set(draftState, propertyPath, toggle !== undefined ? toggle : !get(draftState, propertyPath));
    });
  };
